import { render, staticRenderFns } from "./EiCard.vue?vue&type=template&id=64353b79&scoped=true&"
import script from "./EiCard.vue?vue&type=script&lang=js&"
export * from "./EiCard.vue?vue&type=script&lang=js&"
import style0 from "./EiCard.vue?vue&type=style&index=0&id=64353b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64353b79",
  null
  
)

component.options.__file = "EiCard.vue"
export default component.exports